module.exports = __webpack_public_path__ + "img/870b5cc.jpg";